import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { utils as commonUtils } from '@finley-technologies/common';

import { CreditAgreementsRouter } from './creditAgreements/Router';
import { PortfolioRouter } from './portfolio/Router';
import { CapitalProviderTemplate } from '~/capitalProvider/domains/page/ui/CapitalProviderTemplate';
import {
  RouteErrorBoundary,
  RouteErrorBoundaryFallbackFn,
} from '~/contexts/MonitoringProvider';
import { DefaultErrorRoute } from '~/core/DefaultErrorRoute';

// Constants
const isNotProduction = !commonUtils.EnvUtils.isProduction();

// Helpers
const defaultRouteErrorFallback: RouteErrorBoundaryFallbackFn = ({
  message,
  showErrorToast,
}) => {
  showErrorToast(message);
  return <Navigate to="/" />;
};

// Exports
export const CapitalProviderRouter = () => {
  return (
    <CapitalProviderTemplate>
      <Routes>
        <Route
          path="/portfolio/*"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <PortfolioRouter />
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/credit-agreements/*"
          element={
            isNotProduction ? (
              <RouteErrorBoundary fallback={defaultRouteErrorFallback}>
                <CreditAgreementsRouter />
              </RouteErrorBoundary>
            ) : (
              <Navigate to="/" />
            )
          }
        />

        <Route path="/*" element={<Navigate to="/portfolio" replace />} />
      </Routes>
    </CapitalProviderTemplate>
  );
};
